module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialog/dialog.component.scss
// module id = ./src/app/components/dialog/dialog.component.scss
// module chunks = main